import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const classes = {
  container: css`
    inline-size: ${spacing(50)};
  `,
  header: css`
    padding-block-start: ${spacing(2.5)};
    padding-block-end: ${spacing(1.5)};
  `,
  body: css`
    padding-inline: 0;
  `,
}
